import * as yup from "yup";
import { getValidationSchema } from "../../../../shared/validations/schema";
export const customizeValidationSchema = () => {
  let defaultSchema: any = getValidationSchema([]);
  let customSchema = yup.object().shape({
    email: yup
      .string()
      .required("Email is a required field")
      .trim()
      .email("Invalid Email address format")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Email must include a valid domain (e.g., .com, .net)")
      .min(3, "Email address must be more than 2 characters")
      .max(30, "Email address cannot exceed more than 30 characters"),
  });
  return defaultSchema.concat(customSchema);
};
